import React from "react";
import { Button, Tabs, Typography } from "antd";
import MerchantReports from "./report";
import StoreAdminLayout from "../../../layout/StoreAdminLayout";
import { useNavigate, useParams } from "react-router-dom";

const MerchantDetails = () => {
  const { user_id, merchant_name } = useParams();
  const navigate = useNavigate();

  const items = [
    {
      key: "1",
      label: `Report`,
      children: (
        <MerchantReports user_id={user_id} merchant_name={merchant_name} />
      ),
    },
  ];

  return (
    <StoreAdminLayout>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ flexGrow: 1 }}>
          <Typography style={{ fontWeight: "bold", fontSize: 20 }}>
            {merchant_name}
          </Typography>
        </div>
        <div>
          <Button onClick={() => navigate(-1)}>Go Back</Button>
        </div>
      </div>
      <Tabs defaultActiveKey="1" items={items} />
    </StoreAdminLayout>
  );
};

export default MerchantDetails;
